import React, { Component } from 'react';
import ConsentManager, { IConsentState } from './ConsentManager';

interface ICookieConsentBannerState {
    visible: boolean;
    showSettings: boolean;
    analytics: boolean;
    ads: boolean;
}

class CookieConsentBanner extends Component<unknown, ICookieConsentBannerState> {
    state = {
        visible: false,
        showSettings: false,
        analytics: true,
        ads: true
    };

    private openHandler = () => {
        this.setState(this.stateFromStorage(true));
    };

    private stateFromStorage(showSettings: boolean): ICookieConsentBannerState {
        const saved: IConsentState | null = ConsentManager.read();
        return {
            visible: true,
            showSettings: showSettings,
            analytics: saved ? saved.analytics === true : true,
            ads: saved ? saved.ads === true : true
        };
    }

    componentDidMount() {
        if (typeof window === 'undefined') {
            return;
        }
        const saved = ConsentManager.read();
        this.setState({
            visible: saved === null,
            analytics: saved ? saved.analytics === true : true,
            ads: saved ? saved.ads === true : true
        });
        window.addEventListener('epk-open-cookie-settings', this.openHandler);
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('epk-open-cookie-settings', this.openHandler);
        }
    }

    acceptAll = () => {
        this.setState({ analytics: true, ads: true });
        this.save(true, true);
    };

    rejectAll = () => {
        this.setState({ analytics: false, ads: false });
        this.save(false, false);
    };

    saveSelected = () => {
        this.save(this.state.analytics, this.state.ads);
    };

    save(analytics: boolean, ads: boolean) {
        ConsentManager.save({ analytics: analytics, ads: ads });
        this.setState({ visible: false, showSettings: false });
    }

    renderRow(title: string, desc: string, checked: boolean, disabled: boolean, onChange?: () => void) {
        return (
            <label key={title} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', margin: '10px 0' }}>
                <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange}
                    style={{ marginTop: '3px', width: '16px', height: '16px' }} />
                <span>
                    <strong>{title}</strong>
                    <br />
                    <span style={{ fontSize: '13px', color: '#555' }}>{desc}</span>
                </span>
            </label>
        );
    }

    renderButton(label: string, onClick: () => void, primary: boolean) {
        return (
            <button onClick={onClick}
                style={{
                    padding: '10px 18px',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    border: primary ? 'none' : '1px solid #FF5C00',
                    background: primary ? '#FF5C00' : '#ffffff',
                    color: primary ? '#ffffff' : '#FF5C00'
                }}>
                {label}
            </button>
        );
    }

    render() {
        if (typeof window === 'undefined' || !this.state.visible) {
            return null;
        }

        return (
            <div role="dialog" aria-label="Kolačići"
                style={{
                    position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 9999,
                    background: '#ffffff', boxShadow: '0 -2px 10px rgba(0,0,0,0.2)', padding: '20px'
                }}>
                <div style={{ maxWidth: '1140px', margin: '0 auto' }}>
                    <h5 style={{ margin: '0 0 8px 0' }}>Kolačići i privatnost</h5>
                    <p style={{ margin: '0 0 12px 0', fontSize: '14px' }}>
                        Ova stranica koristi nužne kolačiće potrebne za njen ispravan rad. Analitičke i marketinške kolačiće postavljamo isključivo
                        uz Vašu dozvolu u cilju unapređenja korisničkog iskustva. Više informacija možete pronaći u{' '}
                        <a href="/politika-o-kolacicima">Politici o kolačićima</a>.
                    </p>

                    {this.state.showSettings && (
                        <div style={{ borderTop: '1px solid #ddd', paddingTop: '8px', marginBottom: '12px' }}>
                            {this.renderRow(
                                'Nužni (funkcionalni) kolačići',
                                'Potrebni za rad stranice, prijavu i sigurnost. Uvijek aktivni.',
                                true, true)}
                            {this.renderRow(
                                'Analitički kolačići',
                                'Anonimna statistika korištenja stranice.',
                                this.state.analytics, false,
                                () => this.setState({ analytics: !this.state.analytics }))}
                            {this.renderRow(
                                'Marketinški kolačići',
                                'Korišteni za mjerenje učinkovitosti i ciljanje oglasa.',
                                this.state.ads, false,
                                () => this.setState({ ads: !this.state.ads }))}
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {this.renderButton('Prihvati sve', this.acceptAll, true)}
                        {this.renderButton('Odbij sve', this.rejectAll, false)}
                        {!this.state.showSettings
                            ? this.renderButton('Postavke kolačića', () => this.setState({ showSettings: true }), false)
                            : this.renderButton('Spremi postavke', this.saveSelected, false)}
                    </div>
                </div>
            </div>
        );
    }
}

export default CookieConsentBanner;